import * as React from "react";
import { scoreHelper } from "../../../../helpers";
import { Score } from "../Score";
export const LiveScore = (props) => {
    const score = props.event.isTeamSwap
        ? scoreHelper(props.event)
        : {
            homeScore: props.event.score.homeScore,
            awayScore: props.event.score.awayScore
        };
    return (React.createElement("div", { className: `rj-ev-list__${props.componentPrefix}__section-item rj-ev-list__${props.componentPrefix}__scores`, "data-uat": `div-ev-list-${props.componentPrefix}-scores` },
        React.createElement(Score, { score1: score.homeScore, score2: score.awayScore, sportId: props.event.sportId, scoreboard: props.event.scoreboard, componentPrefix: props.componentPrefix })));
};
//# sourceMappingURL=LiveScore.js.map